module.exports = __webpack_public_path__ + "static/lframe-new-and-used-car-62e25f03fcf3fdff8c8ee559569dcb11.png";